import { camelize, underscore } from 'inflected';
import { metaKey } from '@/scripts/utils';

export default async ({ app, route, store }) => {
  const coverType = getCoverType(route.params.coverType);
  const crumbKey = `i18n/${coverType.product}`;
  let providerBreadcrumbs = null;
  switch (route.path) {
    case `/${coverType.basePath}/`:
      route.meta[0].breadcrumbs = [['i18n/home', '/'], ['i18n/insurance', '/compare-insurance/']];
      break;
    case `/${coverType.basePath}/search/`:
      route.meta[0].breadcrumbs = [['i18n/home', '/'], ['i18n/insurance', '/insurance/'], ['i18n/search']];
      break;
    case `/${coverType.basePath}/your-results/`:
      route.meta[0].breadcrumbs = [['i18n/home', '/'], ['i18n/insurance', '/insurance/'], ['i18n/your-results']];
      break;
  }
  let breadcrumbs = route.meta[0].breadcrumbs;
  if (metaKey(route, 'isProviderPage')) {
    providerBreadcrumbs = [['i18n/home', '/'],
                           ['i18n/insurance', '/insurance/'],
                           [crumbKey, `/${coverType.basePath}/`, 'mobile'],
                           ['i18n/providers', `/${coverType.basePath}/providers/`]];
  } else if (breadcrumbs.length > 2) {
    breadcrumbs.splice(2, 0, [crumbKey, `/${coverType.basePath}/`, 'mobile']);
  } else {
    breadcrumbs.push(crumbKey);
  }
  const jumbotronLifeScope = (metaKey(route, 'jumbotronLifeScope'));
  const jumbotronScope = jumbotronLifeScope ? `${coverType.basePath}.${metaKey(route, 'jumbotronLifeScope')}` : null;
  route.meta[0] = { ...route.meta[0], ...{ breadcrumbs, jumbotronScope, providerBreadcrumbs } };
  store.commit('products/setCoverType', coverType);
};

const getCoverType = (key) => {
  key = key || 'compare-life-insurance';
  const opts = {
    'compare-life-insurance': {
      product: 'life-insurance'
    },
    'compare-mortgage-protection-insurance': {
      life1Key: 'mortgageAmount',
      product: 'mortgage-protection',
      termKey: 'mortgageTerm'
    },
    'compare-serious-illness-cover': {
      product: 'serious-illness'
    },
    'compare-income-protection-insurance': {
      product: 'income-protection'
    }
  }[key];
  opts.basePath = key;
  opts.code = opts.product.split('-').map(char => char[0].toUpperCase()).join('');
  opts[camelize(underscore(opts.product), false)] = true;

  return opts;
};
